export default {
  title: "土地资源资产评价指标确立系统",
  en_title: "Zhuoyue - Scoring",
  version: "2.0"
};
